import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { useState } from "react";
import { MdMoreVert } from "react-icons/md";

interface DialogProps {
  menuButton?: JSX.Element;
  menuItems: {
    title?: string;
    items: SingleMenuItemProps[];
  }[];
  disableButonPropagation?: boolean;
  className?: string;
}

export default function CustomDropDownMenu(props: DialogProps) {
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild={props.menuButton !== undefined}>
        {props.menuButton ?? <MdMoreVert />}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={props.className}>
        {props.menuItems
          .filter((item) => item.items.length)
          .map((menuItem, index) => (
            <div key={`menuitem_${index}`}>
              {index > 0 && <DropdownMenuSeparator />}
              {menuItem.title && (
                <DropdownMenuLabel>{menuItem.title}</DropdownMenuLabel>
              )}
              {menuItem.items.map((item, idx) => (
                <DropdownMenuItem
                  key={`submenuitem_${index}_${idx}`}
                  className="cursor-pointer"
                  onClick={(e) => {
                    if (props.disableButonPropagation) {
                      e.preventDefault();
                      e.stopPropagation();
                      setOpen(false);
                    }
                    item.onClick();
                  }}
                >
                  {item.icon}
                  {item.title}
                </DropdownMenuItem>
              ))}
            </div>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export type SingleMenuItemProps = {
  title: string;
  icon: JSX.Element;
  onClick: () => void;
  disableButonPropagation?: boolean;
};
